
window.refreshADVHomePage = function(){
   console.log("refreshADVHomePage");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("mpu", "mpuPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    .addPosition("intropage", "intropagePh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    //.addPosition("videopreroll", "diretta-play") 
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVCategory = function(){
    console.log("refreshADVCategory");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("mpu", "mpuPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    //.addPosition("videopreroll", "diretta-play")
                    //.addPosition("skyscraper", "skyscraperPh")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVMinisito = function(){
      /***************************/
          console.log("refreshADVMinisito");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("mpu", "mpuPh")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
        /***************************/
  
}


window.refreshADVPlaylist = function(){
   console.log("refreshADVPlaylist");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVCommunity = function(){
   console.log("refreshADVCommunity");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}




window.refreshADVDefault = function(){
    console.log("refreshADVDefault");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    .addPosition("mpu", "mpuPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .addPosition("skyscraper", "skyscraperPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
 
}

window.refreshADVDefault2 = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault2");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    //.addPosition("videopreroll", "post-videoplayer")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVDefault3 = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault3");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    .addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("video", "diretta-play")
                    //.addPosition("audio", "diretta-play")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}



/**********************************FUNZIONI ADV SMARTPHONE**********************************************/

window.refreshADVHomePage_Mobile = function(){
console.log("refreshADVHomePage_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                    .reset()
                    .loadMapper()
                    //temp .addPosition("mpu", "mpuPh")
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVCategory_Mobile = function(){
console.log("refreshADVCategory_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    //temp .addPosition("mpu", "mpuPh")
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVMinisito_Mobile = function(){
     console.log("refreshADVMinisito_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVDefault_Mobile = function(){
    console.log("refreshADVDefault_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("lead_mobile", "leaderboarmobiledPh") 
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true; 
}

window.refreshADVDefault2_Mobile = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault2_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVDefault3_Mobile = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault3_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()                
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVCommunity_Mobile = function(){
console.log("refreshADVCommunity_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVPlaylist_Mobile = function(){
console.log("refreshADVPlaylist_Mobile");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("lead_mobile", "leaderboarmobiledPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

/**********************************FUNZIONI ADV TABLET**********************************************/

window.refreshADVHomePage_Tablet = function(){
//console.log("refreshADVHomePage_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("mpu", "mpuPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}

window.refreshADVCategory_Tablet = function(){
console.log("refreshADVCategory_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("mpu", "mpuPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVMinisito_Tablet = function(){
    
   console.log("refreshADVMinisito_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVPlaylist_Tablet = function(){
console.log("refreshADVPlaylist_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVCommunity_Tablet = function(){
    console.log("refreshADVCommunity_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")   
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}




window.refreshADVDefault_Tablet = function(){
   console.log("refreshADVDefault_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;  

}

window.refreshADVDefault_TabletLandscape = function(){
//    console.log("refreshADVDefault_TabletLandscape");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    .addPosition("mpu", "mpuPh")
                    .addPosition("skyscraper", "skyscraperPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
 
}

window.refreshADVDefault2_Tablet = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault2_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    .addPosition("leaderboard", "leaderboardPh")
                    //.addPosition("videopreroll", "post-videoplayer")
                    //.addPosition("320x100", "320x100")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}


window.refreshADVDefault3_Tablet = function(){
    //Riconosciuta da neodata come location Default1
    //Default2 e Default3 non hanno distinzione di formati (sono gli stessi), questo a seguito di alcune modifiche
    console.log("refreshADVDefault3_Tablet");
    (function ($n, e, o, d, a, t, a$) {
                $n._neoRds = $n._neoRds || {};
                $n._neoRds.Q = $n._neoRds.Q || [];
                // Defines setup function
                $n._neoRds.Q.push(['setup', function () {
                     $n._neoRds.B
                     .reset()
                    .loadMapper()
                    //.addPosition("skin", "skinPh")
                    .addPosition("leaderboard", "leaderboardPh")
                    .refresh()
         }]);
                // Here Javascript Library is loaded
                var x = d.createElement(e), s = d.getElementsByTagName(e)[0];
                x.src = ('https:' == t.protocol ? 'https://js-ssl' : 'http://js') + o;
                x.async = a;
                s.parentNode.insertBefore(x, s);

    })(window, 'scr' + 'ipt', '.neodatagroup.com/uploads/js/rds_async.js', document, 1, location, 1);
    window.advloaded = true;
}
